<template>
  <div class="login">
    <div class="login-box">
      <v-tooltip v-model="show" bottom>
        <template v-slot:activator="{ on }">
          <img :src="brand.logo" alt="Logo Gestão Afiliados" class="logo mb-5 mw-100" />
          <span class="d-flex justify-center mb-2"> {{ $t('auth.loginTitle') }}</span>
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>


      <!-- <v-toolbar-title 
        style="
        font-size: 31px;
        text-align: center;
        width: 100%;
        color: rgb(255, 255, 255);
        font-weight: 100;
        text-transform: uppercase;
        margin-bottom: 1.3rem;
        position: relative;
        z-index: 999999
        ">
        Gestao 
      <v-tooltip v-model="show" right>
        <template v-slot:activator="{ on }">
          <strong @mouseover="show = true" @mouseout="show = false" style="font-weight: 800;"> Única </strong>
        </template>
        <span> v.{{ appVersion }}</span>
      </v-tooltip>

    </v-toolbar-title> -->
     
      <v-card class="card-login">
        <v-form>
          <v-card-text>
            <v-text-field
              ref="emailField"
              class="item mb-3"
              color="white"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-account-circle-outline"
              :label="$t('auth.email')"
              v-model="user.name"
              dense
              filled
              :error-messages="nameErrors"
              @input="$v.user.name.$touch()"
              @blur="$v.user.name.$touch()" />

            <v-text-field 
              class="item mb-4"
              color="white"
              outlined
              filled
              :type="showPassword ? 'text' : 'password'" 
              :label="$t('auth.password')"
              prepend-inner-icon="mdi-key"
              v-model="user.password"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              
              dense
              :error-messages="passwordErrors"
              @input="$v.user.password.$touch()" 
              @blur="$v.user.password.$touch()" />

            <div class="text-right ">
              <a class="login-esqueci-senha-btn mb-2" @click.prevent="showRecoverPasswordModal">{{ $t('auth.forgotPassword') }}</a>
            </div>

          </v-card-text>

          <v-card-actions class="justify-center">
            <v-btn type="submit" color="primary" @click.prevent="submit" class="login-btn" tile :loading="loading">{{ $t('auth.enterBtn') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

      <p class="text-cadastro mt-2"> {{ $t('auth.noAccount') }} <router-link to="/cadastro"> {{ $t('auth.registerLink') }} </router-link></p>
    </div>

    <BrSnackbar :snackbar="snackbar" />
    <recoverPasswordModal/>
    <newPasswordModal/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Events from '../../core/service/events'
import newPasswordModal from './components/modalNewPassword'
import cookies from '@/core/service/session'
import variables from '@/assets/styles/helpers/_variables.scss'
import brand from '@/core/brand'

export default {
  name: 'Login',
  mixins: [validationMixin],
  components: {
    BrSnackbar: () => import('@/views/components/snackbar'),
    recoverPasswordModal: () => import ('./components/modalRecoverPassword'),
    newPasswordModal
  },

  data: () => ({
    show: false,
    snackbar: {
      toggle: false,
      type: null,
      msg: null
    },
    loading: false,
    showPassword: false,
    valid: true,
    user: {
      name: '',
      password: '',
    }
  }),
  
  mounted(){
    this.showNewPasswordModal()
    this.$nextTick(() => {
      this.$refs.emailField.focus()
    })
  },
  computed: {
    variables: () => variables,
    brand: () => brand,
    appVersion () {
      return process.env.VUE_APP_VERSION
    },
    nameErrors () {
      const errors = []
      if (!this.$v.user.name.$dirty) return errors
      !this.$v.user.name.required && errors.push(this.$t('auth.nameRequired'))
      return errors
    },

    passwordErrors () {
      const errors = []
      if (!this.$v.user.password.$dirty) return errors
      !this.$v.user.password.required && errors.push(this.$t('auth.passwordRequired'))
      return errors
    },
  },

  methods: {
    ...mapActions('auth', ['login']),
    ...mapActions('roles', ['clearAcl']),
    submit () {
      const self = this

      //quando efetuar login limpar o regiaoAtual do cookies pois o watch é muito eficiente e seta o ultimo valor após a requisição de remover do cookies.
      cookies.remove('regiaoAtual')
      if (this.$v.user.$invalid) { 
        this.$v.user.$touch()
        return false 
      }

      this.loading = true
      const usernameToNumbers = this.user.name.replace(/\D/g, '')
      this.user.name = usernameToNumbers.length === 11 ? usernameToNumbers : this.user.name.toLowerCase()
      self.login(self.user).then(() => {
        self.$router.replace('/home')
      }).catch(e => {
        console.log('login error', e)
        if (e === 'Afiliado_pendente') {
          this.$router.push({name: 'revisao-conta'})
          return
        }
        this.snackbar = { toggle: true, msg: e, type: 'error' }
        this.loading = false
        return false
      })
    },

    showRecoverPasswordModal () {
      Events.$emit('auth::openModalRecoverPassword')
    },
    
    showNewPasswordModal(){
      let token = this.$router.currentRoute.query.token

      if (token != null) {
        Events.$emit('auth::openModalNewPassword', token)
      }
    }
  },

  validations () {
    return {
      user: {
        name: { required },
        password: { required }
      }
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/styles/auth.scss"></style>